<script>
  import { onMount, onDestroy, createEventDispatcher } from 'svelte';

  import Notification from '@utils/notification';
  import ImageUpload from '@utils/image-upload';
  import ExternalAddService from '@utils/external-add-service';
  import { getCurrentUserStore } from '@stores/current_user';
  import Track from '@utils/track';
  import Url from '@utils/url';
  import BrowserUtils from '@utils/browser-utils';
  import Log from '@utils/log';
  import AffiliateUrl from '@utils/affiliate_url';

  import instagramIcon from '@images/add-rec/instagram.png';
  import emailIcon from '@images/add-rec/email.png';
  import externalIcon from '@images/add-rec/external.png';
  import linkIcon from '@images/add-rec/link.png';
  import phoneIcon from '@images/add-rec/phone.png';

  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');

  import PreloadBox from '@components/PreloadBox.svelte';
  import CustomizationAjax from '@ajax/customization';
  import RecObjectAjax from '@ajax/rec_object';
  import AutofillStatsAjax from '@ajax/autofill_stats';

  import { uniqBy } from 'lodash-es';

  import Autocomplete from '@app-components/Autocomplete.svelte';
  import AmazonAffiliateModal from '@app-components/modal/AmazonAffiliateModal.svelte';
  import RecObjectPreview from './RecObjectPreview.svelte';

  import tippy from 'tippy.js';

  import LoadingSkeleton from '@app-components/LoadingSkeleton.svelte';

  import jQuery from 'jquery';

  const dispatch = createEventDispatcher();

  export let modalId = null;
  export let useOpenStreetMap = false;
  export let mobile = false;
  export let name = null;
  export let webResult = null;
  export let galleryImages = [];
  export let loadingPreview = false;
  export let selectedImages = [];
  export let moveToStepOne = null;
  export let selectedRecObject = null;
  export let focusNote = null;
  export let recommendationNamePlaceholder = null;
  export let showSkip = false;
  export let showBack = true;
  export let showCancel = false;
  export let closeFn = null;
  export let doneButtonHtml = '<span style="padding-left: 14px; padding-right: 14px;">Next: Add note</span>';
  export let customDoneFn = null;
  export let mode = 'new';
  export let recObjectId = null;
  export let focusBrokenLink = false;
  export let brokenLink;
  export let customGroupStore;
  export let preferAffiliate = false;
  export let preferAffiliateTopCount = 3;
  export let localized = true;
  export let searchHelper = '';

  $: selectedUrls = selectedImages.map((x) => x.src);

  let currentUser = getCurrentUserStore('default');
  let group = customGroupStore || groupStore;
  let editableWebResult = webResult;
  let originalEditableWebResult;
  let userClicked = false;

  let allowImageSelect = false;
  let fileInput;
  let totalFilesUploaded = 0;
  let totalFilesProcessed = 0;
  let uploadingPhoto = false;
  let importForLinkEl;
  let loadingUrlImages = false;
  let finishedLoading = false;
  let triggerDoneAfterLoading = false;
  let purpleBoxFixed = true;
  let fetchedCustomization;
  let fetchedRecObject;
  let searchCount = 0;
  let autocompleteResults = [];
  let loadedImages = false;
  let amazonAffiliateModalShow = false;

  let editingRecObject = false;

  let affiliateLinkEnabled = true;
  let loadingAffiliateLink = false;
  let isWeblinkAffiliate = false;
  let isAmazonLinkFromAnotherCountry = false;
  let isLocked = false;
  let ratingShown = false;
  let websiteValueChanged = false;

  let loadingData = false;

  $: isRatingAffiliate =
    editableWebResult &&
    ratingShown &&
    editableWebResult.selectedRating &&
    (editableWebResult.selectedRating.is_affiliate || editableWebResult.selectedRating.affiliate_url);

  let inlineEditConfiguration = {};
  let inlineEditConfigurationName1 = { placeholder: 'Add name' };
  let inlineEditConfigurationName2 = { placeholder: 'Add additional name' };
  let inlineEditConfigurationNeighborhood = { placeholder: 'Add location' };

  let invalidEmail = false;

  let bottomBarWidthOffset = BrowserUtils.isSafari() ? 20 : 35;

  let currentMobileTab = 'details';

  $: if (triggerDoneAfterLoading && finishedLoading) {
    triggerDoneAfterLoading = false;
    triggerDone();
  }

  let carouselStartPosition = 0;

  let fetchFastResult = async function (term) {
    try {
      loadingData = true;
      let data = await ExternalAddService.fetchFast(
        term + searchHelper,
        localized,
        preferAffiliate,
        preferAffiliateTopCount
      );
      loadingData = false;

      if (!data || !data.id) {
        throw 'nothing found';
      }

      fetchImages(data.id);
      fetchSlowResult(data.id);

      showPlaceholderImages();

      webResult = {
        id: data.id,
        name1: data.name,
        phone: data.phone,
        email: data.email,
        website: data.url,
        instagram_handle: data.instagram_handle,
        rating: data.ratings,
        address: [],
      };

      if (data.address && data.address != '') {
        webResult.address = [{ address: data.address }];
      }

      editableWebResult = JSON.parse(JSON.stringify(webResult));

      if (typeof editableWebResult.website !== 'undefined' && editableWebResult.website) {
        checkAffiliateLinkFromWeblink(editableWebResult.website);
      }

      applyDataTransforms();
      focusNameField();
    } catch {
      clearCard();
      allowImageSelect = true;
      finishedLoading = true;
      loadedImages = true;
      isWeblinkAffiliate = false;
    }

    loadingPreview = false;
  };

  let fetchSlowResult = async function (id) {
    let tempSearchCount = searchCount;
    let data = await ExternalAddService.fetchSlow(id);

    if (data && tempSearchCount === searchCount) {
      Object.keys(data).forEach((key) => {
        if (
          data[key] !== null &&
          data[key] !== undefined &&
          (!editableWebResult[key] || editableWebResult[key] === '')
        ) {
          editableWebResult[key] = data[key];
          webResult[key] = data[key];
        }
      });
    }
  };

  let fetchImages = async function (id) {
    loadingUrlImages = true;
    loadedImages = false;
    allowImageSelect = false;

    let tempSearchCount = searchCount;
    let images = await ExternalAddService.fetchImages(id);

    if (tempSearchCount === searchCount) {
      loadingUrlImages = false;
      loadedImages = true;
      allowImageSelect = true;

      galleryImages = uniqBy(images, (i) => i.src);
      selectPreselectedImages();

      finishedLoading = true;
    }
  };

  let selectPreselectedImages = function () {
    selectedImages = [];

    galleryImages.forEach((img) => {
      if (img.preselected) {
        selectedImages.push(img);
        delete img.preselected;
      }
    });

    selectedImages = selectedImages;
  };

  let fetchImagesFromUrl = async function () {
    let url = importForLinkEl.value;

    if (loadingUrlImages) {
      return;
    }

    if (!url || url == '') {
      Notification.send({ text: 'Please enter a link' });
      return;
    }

    loadingUrlImages = true;

    try {
      let images = await ExternalAddService.fetchImagesFromUrl(url);

      if (images.length === 0) {
        Log.info(`[import from link] No images found for url: ${url}`);

        Notification.send({
          text: 'Unfortunately, no images were found at that link',
        });
      } else {
        Notification.send({
          text: 'Successfully imported photos from link',
        });

        setGalleryImages(images.concat(galleryImages));
      }
    } catch {
      Notification.send({
        text: 'Unfortunately, we were not able to find any images. Please try again.',
      });
    }

    importForLinkEl.value = '';
    loadingUrlImages = false;

    jQuery('.step-2-container').scrollTop(0);
  };

  let setGalleryImages = function (images) {
    let uniqImages = uniqBy(images, (i) => i.src);
    galleryImages = uniqImages;
    selectPreselectedImages();
  };

  let showAffiliateLinkForEdit = async function (resp) {
    if (currentUser && currentUser.affiliate_links_enabled) {
      let website = editableWebResult.website;
      let selectedRating = editableWebResult && editableWebResult.rating && editableWebResult.rating['stored-rating'];

      if (website && website != '') {
        if (resp.affiliate_url && resp.affiliate_url != '') {
          affiliateLinkEnabled = true;
          isWeblinkAffiliate = true;
        } else {
          await checkAffiliateLinkFromWeblink(website);
          affiliateLinkEnabled = isWeblinkAffiliate && resp.affiliate_links_enabled;
        }
        isLocked = resp.is_locked;
      } else {
        isWeblinkAffiliate = false;
      }

      if (
        selectedRating &&
        (selectedRating.affiliate_url || selectedRating.is_affiliate) &&
        resp.affiliate_links_enabled
      ) {
        affiliateLinkEnabled = true;
      }
    } else {
      isWeblinkAffiliate = false;
    }
  };

  export const fetchRecObject = async function (id) {
    if (loadingPreview) {
      return;
    }

    resetInlineEditConfiguration();
    finishedLoading = false;

    try {
      let resp = await RecObjectAjax.get(group, { id: id });
      let rating = resp.rec_ratings && resp.rec_ratings[0];
      fetchedRecObject = resp;

      webResult = {
        name1: resp.name1,
        name2: resp.name2,
        phone: resp.phone,
        email: resp.email,
        categories: resp.categories.map((x) => x.name),
        website: resp.weblink,
        instagram_handle: resp.instagram_handle,
        address: resp.addresses,
      };

      if (rating) {
        webResult['rating'] = {};
        webResult['rating']['stored-rating'] = {
          score: rating.rating,
          site_url: rating.site_url,
          number_of_ratings: rating.number_of_reviews,
          affiliate_url: rating.affiliate_url,
        };
      }

      galleryImages = resp.rec_object_photos.map((p) => {
        return {
          view_urls: p.view_urls,
          id: p.id,
          metadata: p.metadata,
          display_style: p.display_style,
          src: p.view_urls['full_size'] || p.view_urls['rect_size'] || p.view_urls['square_size'],
        };
      });

      selectedImages = JSON.parse(JSON.stringify(galleryImages));

      resp.gallery_images.forEach((src) => {
        galleryImages.push({
          src: src,
        });
      });

      editableWebResult = JSON.parse(JSON.stringify(webResult));

      allowImageSelect = true;
      loadingPreview = false;
      loadedImages = true;

      applyDataTransforms();
      if (focusBrokenLink) {
        hightlightBrokenLink();
      } else {
        focusNameField();
      }
      await showAffiliateLinkForEdit(resp);

      originalEditableWebResult = Object.assign({}, editableWebResult);
    } catch {}
    finishedLoading = true;
  };

  export const fetchCustomization = async function (id) {
    if (loadingPreview) {
      return;
    }

    resetInlineEditConfiguration();
    finishedLoading = false;

    try {
      let resp = await CustomizationAjax.get(group, id);
      let rating = resp.rec_ratings && resp.rec_ratings[0];
      fetchedCustomization = resp;

      webResult = {
        name1: resp.name1,
        name2: resp.name2,
        phone: resp.phone,
        email: resp.email,
        categories: resp.categories,
        website: resp.weblink,
        instagram_handle: resp.instagram_url,
        address: resp.addresses,
      };

      if (rating) {
        webResult['rating'] = {};
        webResult['rating']['stored-rating'] = {
          score: rating.rating,
          site_url: rating.site_url,
          number_of_ratings: rating.number_of_reviews,
          affiliate_url: rating.affiliate_url,
        };
      }

      galleryImages = resp.photos.map((p) => {
        return {
          view_urls: p,
          id: Math.floor(Math.random() * 1000000),
          src: p['full_size'],
        };
      });

      selectedImages = JSON.parse(JSON.stringify(galleryImages));

      resp.gallery_images.forEach((src) => {
        galleryImages.push({
          src: src,
        });
      });

      editableWebResult = JSON.parse(JSON.stringify(webResult));
      allowImageSelect = true;
      loadingPreview = false;
      loadedImages = true;

      showAffiliateLinkForEdit(resp);
      applyDataTransforms();
      focusNameField();
    } catch {}

    finishedLoading = true;
  };

  export const fetchWebResult = function (term) {
    if (loadingPreview) {
      return;
    }

    if (term == '') {
      Notification.send({
        text: 'Please enter a search term',
      });

      return;
    }

    resetInlineEditConfiguration();
    removeValidationErrors();

    finishedLoading = false;
    loadingUrlImages = false;
    webResult = null;
    editableWebResult = null;
    galleryImages = [];
    selectedImages = [];
    loadingPreview = true;
    currentMobileTab = 'details';
    searchCount += 1;
    isWeblinkAffiliate = false;
    affiliateLinkEnabled = true;
    loadingAffiliateLink = false;

    term = term && term.trim();

    fetchFastResult(term);
  };

  export const checkForChanged = function () {
    if (
      (editableWebResult && JSON.stringify(editableWebResult) !== JSON.stringify(originalEditableWebResult)) ||
      userClicked
    ) {
      return true;
    } else {
      return false;
    }
  };

  let showPlaceholderImages = function () {
    if (mode === 'new') {
      let images = [
        {
          src: `/images/placeholder-square.png?rand=${Math.floor(Math.random() * 100000000)}`,
          placeholder: true,
        },
        {
          src: `/images/placeholder-square.png?rand=${Math.floor(Math.random() * 100000000)}`,
          placeholder: true,
        },
        {
          src: `/images/placeholder-square.png?rand=${Math.floor(Math.random() * 100000000)}`,
          placeholder: true,
        },
      ];

      galleryImages = images;
      selectedImages = galleryImages;
    }
  };

  let uploadPhotos = function () {
    jQuery(fileInput).click();
    totalFilesUploaded = 0;
    totalFilesProcessed = 0;
  };

  let attachImageUpload = function (node) {
    fileInput = node;

    let cropper = {
      edit: function (data) {
        return new Promise(function (resolve) {
          resolve({ file: data });
        });
      },
    };

    let addFilesToGallery = function (response) {
      let respData = {
        src: response.uploadURL,
        metadata: { source: 'upload' },
        id: Math.floor(Math.random() * 1000000),
        uploaded: true,
        loaded: true,
      };

      galleryImages.unshift(respData);
      selectedImages.unshift(respData);

      totalFilesProcessed += 1;

      if (totalFilesProcessed >= totalFilesUploaded) {
        galleryImages = galleryImages;
        selectedImages = selectedImages;
        uploadingPhoto = false;
      }
    };

    ImageUpload.attach(
      fileInput,
      function (data, uppy) {
        for (var i = 0; i < data.length; i++) {
          var response = data[i];
          totalFilesUploaded = uppy.getFiles().length;
          addFilesToGallery(response);
        }
      },
      () => {
        uploadingPhoto = true;
      },
      {
        cropper: cropper,
        maxNumberOfFiles: 20,
        locale: {
          strings: {
            youCanOnlyUploadX: {
              1: 'Reached limit of %{smart_count} photos for this item',
            },
          },
        },
      }
    );
  };

  let selectImage = function (img) {
    if (allowImageSelect == false) {
      return;
    }

    userClicked = true;
    var idx = selectedUrls.indexOf(img.src);

    if (idx >= 0) {
      selectedImages.splice(idx, 1);
    } else {
      selectedImages.push(img);
    }

    selectedImages = selectedImages;
  };

  let updateImageDisplayStyle = function (imageIndex, carouselIndex) {
    carouselStartPosition = carouselIndex;
    let currentDisplayStyle = selectedImages[imageIndex].display_style || 'cover';
    selectedImages[imageIndex].display_style = currentDisplayStyle == 'cover' ? 'contain' : 'cover';
  };

  let resetInlineEditConfiguration = function () {
    inlineEditConfiguration = {
      name1: inlineEditConfigurationName1,
      name2: inlineEditConfigurationName2,
      neighborhood: inlineEditConfigurationNeighborhood,
    };
  };

  let validateEmailTippyInstance;

  let validateEmail = function (node) {
    let email = String(editableWebResult.email || '');

    invalidEmail = BrowserUtils.emailIsValid(email) !== true;

    if (invalidEmail) {
      if (!validateEmailTippyInstance) {
        validateEmailTippyInstance = tippy(node, {
          content:
            '<div style="background: #dc3545; margin: -5px; padding: 5px; margin-left: -10px; margin-right: -10px; padding-left: 10px;">Looks like there’s a typo with the email, please correct it</div>',
          placement: 'top',
          allowHTML: true,
          arrow: false,
          hideOnClick: false,
          trigger: 'manual',
        });
        validateEmailTippyInstance.show();
      }
    } else if (validateEmailTippyInstance) {
      validateEmailTippyInstance.destroy();
      validateEmailTippyInstance = undefined;
    }

    return invalidEmail;
  };

  let removeValidationErrors = function () {
    try {
      if (validateEmailTippyInstance) {
        validateEmailTippyInstance.destroy();
        validateEmailTippyInstance = undefined;
      }

      invalidEmail = false;
    } catch {}
  };

  let checkAffiliateLinkFromWeblink = async function (url) {
    if (currentUser && currentUser.affiliate_links_enabled) {
      if (group && url && url != '') {
        isWeblinkAffiliate = false;
        loadingAffiliateLink = true;
        let resp = await AffiliateUrl.testUrl(url);
        loadingAffiliateLink = false;

        if (resp && resp.is_processed && resp.is_affiliate) {
          isWeblinkAffiliate = true;
        }

        if (resp) {
          isLocked = resp.is_locked;
        }

        if (!resp.url_matches_amazon_country) {
          isAmazonLinkFromAnotherCountry = true;
        }
      } else {
        isWeblinkAffiliate = false;
      }
    }
  };

  let applyDataTransforms = function () {
    if (editableWebResult.website && editableWebResult.website != '') {
      editableWebResult.website = Url.urlWithoutHttpsOrWww(editableWebResult.website);
    }

    if (editableWebResult.instagram_handle && editableWebResult.instagram_handle != '') {
      let match = /^(?:@|(?:https?:)?(?:\/)*(?:www\.)?instagr(?:\.am|am\.com)\/)?((?:p\/)?[\w\.-]+)\/?/.exec(
        editableWebResult.instagram_handle
      );

      if (match) {
        editableWebResult.instagram_handle = match[1];
      }
    }
  };

  let focusNameField = async function () {
    if (!mobile) {
      try {
        let el = await BrowserUtils.waitForElement('.name1');
        el.find('span').focus();
      } catch {}
    }
  };

  const hightlightBrokenLink = async function () {
    jQuery(`#mobile-grid-focus-input`).focus();
    setTimeout(async () => {
      let elem = await BrowserUtils.waitForElement('#editable-web-result-weblink');
      if (mobile) {
        if (elem) {
          elem = document.getElementById('editable-web-result-weblink');
        }
        await BrowserUtils.goToElement(elem, { behavior: 'smooth', block: 'start', inline: 'start' });
        await BrowserUtils.focusAndHighlight(elem);
      } else {
        elem.focus();
      }
    }, 500);
  };

  let triggerSkip = function () {
    try {
      Log.info(
        `[SKIP] ${currentUser && currentUser.name} skipped auto-fill for "${name}" on ${
          group && group.name
        } (https://benable.com${group && group.path})`
      );
    } catch {}

    addTemporaryRecObject();
    moveToStepOne();
    focusNote();
  };

  let triggerDone = function () {
    triggerDoneAfterLoading = false;
    removeValidationErrors();

    if (addSelectedRecObject()) {
      if (customDoneFn) {
        customDoneFn(selectedRecObject);
      } else if (mode === 'edit' && recObjectId) {
        saveEditRecObject();
      } else {
        moveToStepOne();
        focusNote();
      }
    }
  };

  let blurOnEnter = function (e) {
    var which = event.which || event.keyCode || 0;

    if (which == 13) {
      jQuery(e.target).blur();
    }
  };

  let addTemporaryRecObject = function () {
    selectedRecObject = {
      id: null,
      name1: name,
      rec_object_photos: [],
    };
  };

  let addSelectedRecObject = function () {
    if (!editableWebResult) {
      Notification.send({
        text: 'Please click done again',
      });
      return false;
    }

    if (!editableWebResult.name1 && editableWebResult.name1 == '') {
      Notification.send({
        text: 'Please enter a name',
      });
      return false;
    }

    var data = {
      id: null,
      matchField: 'name1',
      name1: editableWebResult.name1,
      phone: editableWebResult.phone,
      address: editableWebResult.address,
      weblink: editableWebResult.website,
      email: editableWebResult.email,
      rating: editableWebResult.rating,
      categories: editableWebResult.categories,
      selectedRating: editableWebResult.selectedRating,
      instagram_handle: editableWebResult.instagram_handle,
      rec_object_photos: selectedImages,
      affiliate_links_enabled: currentUser.affiliate_links_enabled && affiliateLinkEnabled,
      gallery_images: galleryImages
        .filter((x) => x.loaded && !x.duplicate && !x.hidden && !x.transparent && !selectedUrls.includes(x.src))
        .map((x) => x.src),
      external_rec_object: true,
    };

    if (fetchedCustomization) {
      data['rec_object_customization_id'] = fetchedCustomization.id;
    }

    if (fetchedRecObject) {
      data['rec_object_id'] = fetchedRecObject.id;
    }

    if (inlineEditConfiguration['name2']) {
      data['name2'] = editableWebResult.name2 || '';
    }

    if (inlineEditConfiguration['neighborhood'] && editableWebResult.address && editableWebResult.address[0]) {
      data['address'] = editableWebResult.address[0];
    }

    selectedRecObject = JSON.parse(JSON.stringify(data));
    return true;
  };

  let applyInlineEditChangesToEditableResult = function (data) {
    if (editableWebResult[data.field] != data.text) {
      trackEdit(data.field, data.text);
    }

    if (data.field == 'name1') {
      editableWebResult.name1 = data.text;
    } else if (data.field == 'name2') {
      editableWebResult.name2 = data.text;
    } else if (data.field == 'neighborhood') {
      editableWebResult.address = [{ address: data.text }];
    }
  };

  let setupTippyForInstagram = function (node, handle) {
    var tippyObj;
    var setup = function (handle) {
      if (handle == '' && tippyObj) {
        tippyObj.destroy();
        tippyObj = undefined;
      } else if (handle && handle != '') {
        var content = `<a onclick="window.open('https://instagram.com/${handle}')" style='color: white; word-wrap: break-word;' href='#' target='_blank'>https://instagram.com/${handle}</a>`;

        if (tippyObj) {
          tippyObj.setContent(content);
        } else {
          tippyObj = tippy(node, {
            content,
            allowHTML: true,
            interactive: true,
            placement: 'bottom',
          });
        }
      }
    };

    setup(handle);

    return {
      update(x) {
        setup(x);
      },
    };
  };

  let setupTippyForWebsite = function (node, website) {
    var tippyObj;
    var setup = function (site) {
      if (site == '' && tippyObj) {
        tippyObj.destroy();
        tippyObj = undefined;
      } else if (site && site != '') {
        var content = `<a onclick="window.open('https://${site}')" style='color: white; word-wrap: break-word;' href='#' target='_blank'>${site}</a>`;

        if (tippyObj) {
          tippyObj.setContent(content);
        } else {
          tippyObj = tippy(node, {
            content,
            allowHTML: true,
            interactive: true,
          });
        }
      }
    };

    setup(website);
    return {
      update(x) {
        setup(x);
      },
    };
  };

  let setupTippy = function (node) {
    tippy(node);
  };

  let setupTippyForEmail = function (node, email) {
    var tippyObj;
    var setup = function (x) {
      if (x == '' && tippyObj) {
        tippyObj.destroy();
        tippyObj = undefined;
      } else if (x && x != '') {
        x = `<span style="word-wrap: break-word;">${x}</span>`;
        if (tippyObj) {
          tippyObj.setContent(x);
        } else {
          tippyObj = tippy(node, { content: x, allowHTML: true });
        }
      }
    };

    setup(email);

    return {
      update(x) {
        setup(x);
      },
    };
  };

  let setupFixedRightSide = function () {
    if (!mobile) {
      var height = jQuery('body').height();
      purpleBoxFixed = height >= 776;
    }
  };

  let trackRefresh = function () {
    Track.autofillRefreshed({ user: currentUser, group, name });
  };

  let storeStats = function (keyword) {
    AutofillStatsAjax.stepTwo(modalId, keyword, group.id);
  };

  let trackEdit = function (field, value) {
    Track.autofillEdited({
      user: currentUser,
      group,
      field,
      value,
    });
  };

  let saveEditRecObject = async function () {
    if (editingRecObject) {
      return;
    }
    editingRecObject = true;
    try {
      let recObject = recObjectsStore.find(recObjectId);
      let deepClone = jQuery.extend({}, selectedRecObject);

      deepClone['rec_object_photos'] = deepClone['rec_object_photos'].map((x) => {
        if (x['src']) {
          return {
            metadata: x['metadata'],
            display_style: x['display_style'],
            view_urls: {
              full_size: x['src'],
              square_size: x['src'],
              rect_size: x['src'],
            },
          };
        }
      });

      deepClone['instagram_url'] = deepClone['instagram_handle'];

      if (typeof deepClone['address'] === 'object' && deepClone['address']['address']) {
        deepClone['addresses'] = [deepClone['address']];
      } else {
        deepClone['addresses'] = [];
      }

      if (typeof deepClone['selectedRating'] === 'object' && deepClone['selectedRating']['rating']) {
        deepClone['rec_ratings'] = [deepClone['selectedRating']];
      } else {
        deepClone['rec_ratings'] = [];
      }

      deepClone['gallery_images'] = galleryImages
        .filter((x) => x.loaded && !x.duplicate && !x.transparent && !x.hidden && !selectedUrls.includes(x.src))
        .map((x) => x.src);

      await CustomizationAjax.create(group, recObject, JSON.stringify(deepClone));

      recObject.set(await RecObjectAjax.get(group, recObject));

      // trigger update of recObjectsStore
      recObjectsStore.runCallbacks();

      Notification.send({
        text: 'Recommendation has been saved!',
      });

      dispatch('edited', deepClone);
    } catch (err) {
      if (err) {
        if (err.full_errors && err.full_errors.length > 0) {
          let msg = err.full_errors[0];
          Notification.send({
            text: msg,
            type: 'error',
          });
        } else {
          Notification.send({
            text: 'Unable to update recommendation. We will look into this issue!',
            type: 'error',
          });
        }
      }
    }
    editingRecObject = false;
  };

  let clearCard = function () {
    isWeblinkAffiliate = false;
    isLocked = false;

    editableWebResult = {
      website: '',
      email: '',
      phone: '',
      instagram_handle: '',
    };

    webResult = {};
    selectedImages = [];

    try {
      Log.info(
        `[CLEAR CARD] ${currentUser && currentUser.name} cleared card for "${name}" on ${
          group && group.name
        } (https://benable.com${group && group.path})`
      );

      Track.autofillClearCard({ user: currentUser, group: group });
    } catch {}

    focusNameField();
  };

  let onImageLoaded = async (event, img) => {
    img.loaded = true;
    galleryImages = galleryImages;
  };

  let onImageFailed = (img) => {
    img.failed = true;
    galleryImages = galleryImages;
  };

  let setupTooltip = function (node) {
    tippy(node);
  };

  let isAmazonLink = function (url) {
    if (!url) {
      return false;
    }

    return url.includes('amazon.');
  };

  jQuery(window).on('window-resize-stopped', () => {
    setupFixedRightSide();
  });

  setupFixedRightSide();

  onMount(() => {
    userClicked = false;

    if (recObjectId) {
      fetchRecObject(recObjectId);
    }
  });

  onDestroy(() => {
    removeValidationErrors();
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.photos-container) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .step-2-container {
    display: flex;
    flex-direction: column;
    margin-top: -10px;
    height: calc(100vh - 170px);
    overflow-x: hidden;
    overflow-y: auto;
    margin-right: -30px;

    .step-2-search-bar {
      position: relative;
      max-width: 892px;
      width: calc(100% - 15px);
      margin-bottom: 20px;
    }

    .step-2-left-right {
      display: flex;

      .preload-box-container {
        width: 540px;
        height: 600px;
      }

      .right-side {
        display: flex;
        width: 292px;
        /* margin-left: 60px; */
        flex-shrink: 0;
        align-items: flex-start;
        position: relative;
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;

        .photos-label-container {
          display: flex;
          align-items: center;

          .photos-label {
            font-weight: 500;
            font-size: 16px;
            line-height: 26px;
            flex: 1;
          }

          .photos-upload-button {
            cursor: pointer;
            display: flex;
            align-items: center;

            img {
              margin-right: 8px;
            }

            span {
              font-weight: 400;
              font-size: 14px;
              line-height: 17px;
              color: #a893f9;
            }

            &:hover {
              span {
                color: #7054dc;
              }
            }
          }
        }

        .photos-url-container {
          margin-top: 16px;
          position: relative;

          .photos-url-button {
            opacity: 0.5;
            background: #a893f9;
            padding: 10px;
            border-radius: 10px;
            position: absolute;
            cursor: pointer;
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            top: 4px;
            right: 6px;
          }

          &:hover {
            .photos-url-button {
              opacity: 1 !important;
            }
          }

          input {
            width: 100%;
            border: 2px solid #ececec;
            font-size: 15px;
            font-weight: 400;
            color: #666;
            line-height: 20px;
            border-radius: 12px;
            padding-left: 10px;
            height: 40px;
            padding-right: 50px;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::placeholder {
              color: black;
              opacity: 0.35;
              font-weight: normal;
            }

            &:focus {
              border-color: #a893f9;
              background: #ede9ff;
              caret-color: #a893f9;
              outline: none;
            }

            &:hover {
              background-color: #ede9ff;
              outline: none;
              caret-color: #a893f9;
            }
          }
        }

        .photo-gallery {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          margin-top: 20px;
          margin-right: -10px;

          .photo-gallery-single {
            position: relative;

            .select-image-number {
              position: absolute;
              right: 10px;
              top: 0px;
              background: #a893f9;
              color: white;
              padding: 8px;
              border-radius: 8px;
              font-size: 12px;
              cursor: pointer;
            }

            .gallery-single-image-placeholder {
              cursor: unset !important;

              &:hover {
                border: 4px solid transparent !important;
              }
            }

            .gallery-single-image {
              width: 143px;
              object-fit: cover;
              margin-right: 8px;
              margin-bottom: 8px;
              border-radius: 8px;
              border: 4px solid transparent;
              cursor: pointer;
              min-height: 60px;

              &:hover {
                border: 4px solid #e4dff7;
              }
            }

            .gallery-single-image-selected {
              border: 4px solid #a893f9 !important;
            }
          }
        }
      }

      .left-side {
        display: flex;
        width: 540px;
        flex-shrink: 0;
        align-items: flex-start;
        top: 0px;

        .purple-box {
          background: #f5f3fc;
          border-radius: 24px;
          width: 540px;
          min-height: 300px;
          padding: 24px;
        }

        .preview-more-info-container {
          border-radius: 20px;
          padding: 20px;
          display: flex;
          flex-wrap: wrap;
          background: white;
          margin-top: 8px;

          .single-more-info {
            width: 50%;
            padding-right: 24px;
            flex-shrink: 0;
            display: flex;
            align-items: center;

            img {
              margin-right: 7px;
              width: 16px;
              height: 16px;
            }

            .link-circle-dollar {
              width: 20px;
              height: 20px;
              margin-left: 8px;
            }
          }
        }

        .affiliate-link-container {
          display: flex;
          align-items: center;

          .aff-link-option {
            margin-left: 15px;
            font-size: 14px;
            line-height: 20px;
            color: #896bd9;
            font-weight: 500;
            cursor: pointer;
            display: flex;
            align-items: center;

            .badge-on {
              background: #e7f9f3;
              border-radius: 12px;
              width: 38px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              line-height: 16px;
              color: #2caf87;
              font-weight: 600;
              margin-left: 12px;
              height: 24px;
              max-height: 24px;
            }

            .badge-off {
              background: #ececec;
              border-radius: 12px;
              width: 43px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              line-height: 16px;
              color: #7f7f7f;
              font-weight: 600;
              margin-left: 12px;
              height: 24px;
              max-height: 24px;
            }
          }

          .no-aff-link-option {
            font-size: 15px;
            line-height: 24px;
            color: #7f7f7f;
            font-weight: 400;

            &.with-image {
              display: flex;
              justify-content: center;
            }

            .help-icon {
              margin-left: 6px;
              cursor: pointer;
            }

            .amazon-click-to-enable {
              margin-left: 15px;
              color: #8e71ff;
              cursor: pointer;

              &:hover {
                color: #7054dc;
              }
            }
          }

          .locked-affiliate {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .locked-affiliate-text {
              color: #7f7f7f;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 20px;
            }

            .locked-affiliate-button {
              display: flex;
              height: 36px;
              padding: 0px 16px;
              justify-content: center;
              align-items: center;
              gap: 8px;
              color: #fff;
              font-size: 14px;
              font-weight: 500;
              border-radius: 999px;
              background: #7a5cfa;
              width: fit-content;
              cursor: pointer;

              &:hover {
                background: #6649e0;
              }
            }
          }
        }
      }
    }

    .refresh-button {
      width: 40px;
      height: 40px;
      cursor: pointer;
      background: #a893f9;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 5px;
      position: absolute;
      margin-top: 5px;
      z-index: 1;
    }

    .invalid-input {
      border: 2px solid #dc3545 !important;

      &:hover,
      &:focus {
        border: 2px solid #a893f9 !important;
      }
    }

    .purple-box-input {
      border: 2px solid transparent;
      width: 100%;
      border-radius: 7px;
      cursor: text;
      font-size: 15px;
      font-weight: 500;
      color: #8e71ff;
      line-height: 20px;
      margin-bottom: 2px;
      text-overflow: ellipsis;

      &::placeholder {
        color: black;
        opacity: 0.5;
        font-weight: normal;
      }

      &:focus {
        border-color: #a893f9;
        background: #ede9ff;
        caret-color: #a893f9;
        outline: none;
      }

      &:hover {
        background-color: #ede9ff;
        outline: none;
        caret-color: #a893f9;
      }
      &.broken-link {
        color: #ff5567;
        &:focus {
          background: #fff4f5;
          border: 2px solid #ff5567;
          border-radius: 12px;
          caret-color: #ff5567;
          outline: none;
        }
        &:hover {
          background: #fff4f5;
          outline: none;
          caret-color: #ff5567;
        }
      }
    }

    .single-line-preloader {
      padding-left: 12px;
      height: 8px;
      width: 100%;
    }
  }

  .step-2-bottom-bar {
    background: white;
    width: 100%;
    display: flex;
    align-items: center;
    height: 70px;
    align-items: center;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
    border-radius: 0px 0px 24px 24px;
    margin-left: -30px;
    width: calc(100% + 70px);
    padding-left: 30px;
    padding-right: 60px;

    .btns {
      min-width: 95px;
      height: 48px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      flex-shrink: 0;
      border-radius: 15px;
    }

    .back-btn {
      border: 2px solid #e8e8e8;

      &:hover {
        background: black;
        color: white;
        border: 2px solid black;
      }
    }

    .skip-btn {
      &:hover {
        color: #8e71ff;
      }
    }

    .done-btn {
      background: #a893f9;
      color: white;
      box-shadow: 0px 13px 40px rgba(168, 147, 249, 0.394586);

      &:hover {
        background: #7054dc;
      }
    }
  }

  .mobile {
    margin-top: 30px;
    height: unset;
    margin-right: -20px;
    margin-left: -20px;

    .photo-gallery {
      justify-content: center !important;
    }

    .step-2-search-bar {
      width: calc(100% - 40px);
      margin-left: 20px;
    }

    .step-2-left-right {
      flex-direction: column;

      .preload-box-container {
        width: 100%;
        height: 300px;
      }

      .right-side {
        margin-left: 20px !important;
        width: calc(100% - 40px) !important;
        padding-bottom: 75px;
      }

      .left-side {
        width: 100%;

        .preload-box-container {
          margin-left: 20px;
          margin-right: 20px;
        }

        .affiliate-link-container {
          flex-direction: row !important;
        }

        .purple-box {
          border-radius: 0px;
          min-height: unset;
          width: 100%;
          padding: 20px;
          padding-bottom: 75px;

          .preview-more-info-container {
            flex-wrap: unset;
            flex-direction: column;

            .single-more-info {
              min-height: 36px;
              width: 100%;
              padding-right: 0px;
            }

            .link-circle-dollar {
              margin-right: 12px;
            }
          }
        }
      }

      .right-side {
        width: 100%;
      }

      .no-aff-link-option {
        .amazon-click-to-enable {
          display: block;
          margin-left: 0px !important;
        }
      }
    }
  }

  .mobile-bottom-bar {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 0px;
    background: unset;
    margin-left: 0px;
    margin-right: 0px;

    .skip-btn {
      margin-right: auto;
    }
  }

  .mobile-step-2-bottom-bar-container {
    position: fixed;
    bottom: 0;
    max-width: 600px;
    margin-left: -20px;
    background: white;

    .done-btn {
      margin-left: auto;
    }
  }

  .details-photo-bar {
    background: #000;
    box-shadow: 0px 8px 48px rgba(61, 38, 121, 0.08);
    border-radius: 12px;
    left: calc(50% - 115px);
    width: 215px;
    bottom: 86px;
    position: fixed;
    height: 43px;
    display: flex;

    .details-tab {
      flex: 1;
      flex-shrink: 0;
      color: white;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        opacity: 0.5;
        font-weight: 600;
      }
    }

    .selected-tab {
      span {
        opacity: 1;
      }

      &:after {
        border-bottom: 3px solid #a893f9;
        content: ''; /* This is necessary for the pseudo element to work. */
        display: block; /* This will put the pseudo element on its own line. */
        margin: 0 auto; /* This will center the border. */
        width: 20%; /* Change this to whatever width you want. */
        position: absolute;
        bottom: 0px;
      }
    }
  }

  .low-res-container {
    position: absolute;
    height: 24px;
    bottom: 12px;
    left: 4px;
    right: 12px;
    background: rgba(0, 0, 0, 0.6);
    color: rgb(255, 183, 104);
    display: flex;
    align-items: center;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    cursor: pointer;

    .low-res-text {
      font-size: 12px;
      line-height: 16px;
      font-weight: bold;
      margin-left: 10px;
    }

    svg {
      margin-left: 8px;
    }
  }

  .hidden {
    display: none;
  }

  .checkbox-container {
    flex-shrink: 0;
    position: relative;
    display: inline-block;
    width: 60px;
    height: 32px;

    .togger-enabled {
      background-color: #a893f9 !important;
      border-color: #a893f9 !important;

      &:before {
        transform: translateX(24px) !important;
        background: white !important;
      }
    }

    .ui-toggler {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      border: 2px solid #ececec;
      border-radius: 999px;
      transition: 0.4s;

      &:before {
        position: absolute;
        content: '';
        height: 24px;
        width: 24px;
        left: 4px;
        bottom: 2px;
        background-color: #ececec;
        border-radius: 50%;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
  }
</style>

<div use:attachImageUpload bind:this={fileInput} style="display: none" />

{#if mobile}
  <div
    class="mobile-back-btn"
    style="margin-top: -10px; display: inline-block; {mode === 'new' ? 'visibility: visible;' : 'visibility: hidden;'}"
    on:click={() => {
      removeValidationErrors();
      moveToStepOne();
    }}>
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 9H1" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 17L1 9L8 1" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
{/if}

{#if amazonAffiliateModalShow}
  <AmazonAffiliateModal
    mobile={mobile}
    bind:showModal={amazonAffiliateModalShow}
    on:close={async () => {
      amazonAffiliateModalShow = false;
      await checkAffiliateLinkFromWeblink(editableWebResult.website);
      affiliateLinkEnabled = isWeblinkAffiliate;
    }} />
{/if}

<div
  class="step-2-container purple-scrollbar {autocompleteResults.length === 0
    ? 'without-autocomplete-results'
    : 'with-autocomplete-results'} {editableWebResult ? 'with-result' : 'without-result'} {name
    ? 'with-name'
    : 'without-name'}"
  class:mobile={mobile}>
  <div class="step-2-search-bar" class:hidden={currentMobileTab === 'photos'}>
    {#if mode === 'new'}
      {#if !loadingPreview}
        <div
          class="refresh-button"
          on:click={() => {
            storeStats(name);
            fetchWebResult(name);
            trackRefresh();
          }}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
              <rect width="14" height="14" fill="white" />
            </mask>
            <g mask="url(#mask0)">
              <path
                d="M12.0583 6.9583C11.7754 6.9583 11.5041 7.06837 11.3041
              7.26429C11.1041 7.46021 10.9917 7.72593 10.9917 8.00301C10.992
              8.77091 10.7618 9.52195 10.3296 10.1626C9.89734 10.8033 9.28225
              11.3053 8.56089 11.6061C7.83952 11.907 7.04374 11.9933 6.27263
              11.8545C5.50152 11.7156 4.78914 11.3577 4.22419 10.8252C3.65924
              10.2928 3.26668 9.60934 3.09539 8.85999C2.92409 8.11064 2.98163
              7.3285 3.26084 6.61094C3.54004 5.89338 4.02858 5.27211 4.66563
              4.82448C5.30268 4.37684 6.06009 4.12263 6.84356
              4.09348V6.14575C6.84356 6.40112 7.01896 6.49399 7.23704
              6.35469L11.6649 3.46665C11.7138 3.44279 11.755 3.40603 11.7837
              3.36051C11.8125 3.31498 11.8278 3.2625 11.8278 3.20896C11.8278
              3.15542 11.8125 3.10294 11.7837 3.05741C11.755 3.01189 11.7138
              2.97513 11.6649 2.95127L7.23704 0.0632284C7.01896 -0.0807091
              6.84356 0.0353696 6.84356 0.267527V2.00406C5.63929 2.0342
              4.47083 2.41148 3.48437 3.0887C2.49791 3.76593 1.73725 4.71302
              1.29756 5.8115C0.857867 6.90997 0.75867 8.11104 1.01238
              9.26445C1.26608 10.4179 1.86143 11.4724 2.72393 12.2961C3.58642
              13.1198 4.67778 13.6761 5.86145 13.8954C7.04511 14.1148 8.26853
              13.9874 9.37865 13.5292C10.4888 13.0709 11.4363 12.3023 12.1026
              11.3194C12.769 10.3364 13.1246 9.18288 13.125 8.00301C13.125
              7.72593 13.0126 7.46021 12.8126 7.26429C12.6125 7.06837 12.3412
              6.9583 12.0583 6.9583Z"
                fill="white" />
            </g>
          </svg>
        </div>
      {/if}

      <Autocomplete
        inputStyle={loadingPreview ? '' : 'padding-right: 60px;'}
        mode="dropdown"
        height={260}
        width={'100%'}
        focus={false}
        placeholder={recommendationNamePlaceholder}
        bind:value={name}
        bind:autocompleteResults={autocompleteResults}
        mobile={mobile}
        on:selected={(e) => {
          if (e.detail.term && e.detail.term.id) {
            name = e.detail.term.name1;

            if (e.detail.term.type === 'customization') {
              fetchCustomization(e.detail.term.id);
            } else if (e.detail.term.type === 'recobject') {
              fetchRecObject(e.detail.term.id);
            }
          } else {
            name = e.detail.term;
            storeStats(name);
            fetchWebResult(e.detail.term);
          }
        }} />
    {/if}
  </div>

  <div class="step-2-left-right">
    <div
      class="left-side"
      class:hidden={mobile && currentMobileTab !== 'details'}
      style={purpleBoxFixed ? 'position: sticky;' : ''}>
      {#if loadingPreview && !mobile}
        <div class="preload-box-container">
          <PreloadBox />
        </div>
      {:else if editableWebResult || mobile}
        <div class="purple-box">
          <div>
            <RecObjectPreview
              mobile={mobile}
              clearCard={clearCard}
              currentUser={currentUser}
              bind:result={editableWebResult}
              bind:ratingShown={ratingShown}
              resultImages={selectedImages}
              updateImageDisplayStyle={updateImageDisplayStyle}
              affiliateLinkEnabled={affiliateLinkEnabled}
              loadingPreview={loadingPreview}
              loadingData={loadingData}
              startPosition={carouselStartPosition}
              ratingWebResult={editableWebResult}
              useOpenStreetMap={useOpenStreetMap}
              on:inline-edit={(e) => {
                applyInlineEditChangesToEditableResult(e.detail);
              }} />
          </div>

          {#if editableWebResult && currentUser && currentUser.affiliate_links_enabled && currentUser.cashback_enabled}
            <div class="preview-more-info-container affiliate-link-container">
              {#if !editableWebResult}
                <div style="display: flex; align-items: center; color: #777;">
                  <i class="fa fa-spin fa-spinner" />
                  <div style="margin-left: 15px; font-size: 14px;">Searching for Auto-Affiliate link</div>
                </div>
              {:else if isWeblinkAffiliate || isRatingAffiliate}
                {#if isLocked}
                  <div class="locked-affiliate">
                    <div class="locked-affiliate-text">Unlock commissions for this site by inviting friends</div>
                    <div class="locked-affiliate-button" on:click={() => window.open('/app_invites')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00067 2.50024C6.33588 2.50024 4.98631 3.84982 4.98631 5.51461V6.89912H11.015V5.5146C11.015 3.84982 9.66545 2.50024 8.00067 2.50024ZM3.48631 5.51461V6.89912H2.80469C2.2524 6.89912 1.80469 7.34683 1.80469 7.89912V13.9999C1.80469 14.5522 2.2524 14.9999 2.80469 14.9999H13.1964C13.7487 14.9999 14.1964 14.5522 14.1964 13.9999V7.89912C14.1964 7.34683 13.7487 6.89912 13.1964 6.89912H12.515V5.5146C12.515 3.02139 10.4939 1.00024 8.00067 1.00024C5.50746 1.00024 3.48631 3.02139 3.48631 5.51461ZM3.30469 8.39912V13.4999H12.6964V8.39912H3.30469ZM7.36531 10.8459C7.36531 10.4952 7.64966 10.2108 8.00042 10.2108C8.35118 10.2108 8.63553 10.4952 8.63553 10.8459C8.63553 11.1967 8.35118 11.481 8.00042 11.481C7.64966 11.481 7.36531 11.1967 7.36531 10.8459ZM8.00042 8.91081C6.93169 8.91081 6.06531 9.77719 6.06531 10.8459C6.06531 11.9147 6.93169 12.781 8.00042 12.781C9.06915 12.781 9.93553 11.9147 9.93553 10.8459C9.93553 9.77719 9.06915 8.91081 8.00042 8.91081Z"
                          fill="white" />
                      </svg>
                      <span>Invite friends</span>
                    </div>
                  </div>
                {:else}
                  <div class="checkbox-container">
                    <span
                      on:click={() => {
                        userClicked = true;
                        affiliateLinkEnabled = !affiliateLinkEnabled;
                      }}
                      class="ui-toggler"
                      class:togger-enabled={affiliateLinkEnabled} />
                  </div>
                  <div
                    on:click={() => {
                      userClicked = true;
                      affiliateLinkEnabled = !affiliateLinkEnabled;
                    }}
                    class="aff-link-option">
                    {mobile ? 'Auto-affiliate link' : 'Benable auto-affiliate link'}
                    {#if affiliateLinkEnabled}
                      <div class="badge-on">ON</div>
                    {:else}
                      <div class="badge-off">OFF</div>
                    {/if}
                  </div>
                {/if}
              {:else if loadingAffiliateLink}
                <div style="display: flex; align-items: center; color: #777;">
                  <i class="fa fa-spin fa-spinner" />
                  <div style="margin-left: 15px; font-size: 14px;">Searching for Auto-Affiliate link</div>
                </div>
              {:else if isAmazonLink(editableWebResult.website)}
                {#if currentUser.amazon_affiliate_country && isAmazonLinkFromAnotherCountry}
                  <div class="no-aff-link-option">
                    Amazon Associates ID configured for {currentUser.amazon_affiliate_country} links
                    <br />
                    <span
                      class="amazon-click-to-enable"
                      style="margin-left: 0px"
                      on:click={() => (amazonAffiliateModalShow = true)}>Click here to change</span>
                  </div>
                {:else}
                  <div class="no-aff-link-option">
                    Amazon auto-affiliate is OFF <span
                      class="amazon-click-to-enable"
                      on:click={() => (amazonAffiliateModalShow = true)}>Click here to enable</span>
                  </div>
                {/if}
              {:else}
                <div class="no-aff-link-option with-image">
                  Auto-affiliate links are not available for this site
                  <img
                    class="help-icon"
                    alt="help-icon"
                    src="/emojis/info-icon.svg"
                    use:setupTippy
                    data-tippy-content={'Check your Dashboard for a list of Benable’s available affiliate partnerships!'} />
                </div>
              {/if}
            </div>
          {/if}

          {#if editableWebResult}
            <div class="preview-more-info-container">
              <div class="single-more-info">
                {#if brokenLink}
                  <img src="/images/alert.svg" alt="link-icon" />
                {:else}
                  <img src={linkIcon} alt="link-icon" />
                {/if}
                {#if editableWebResult?.website || !loadingData}
                  <input
                    autocomplete="new-password"
                    on:keyup={blurOnEnter}
                    class="purple-box-input {brokenLink ? 'broken-link' : ''}"
                    id="editable-web-result-weblink"
                    type="text"
                    placeholder="Add a website"
                    bind:value={editableWebResult.website}
                    use:setupTippyForWebsite={editableWebResult.website}
                    on:change={(_e) => {
                      websiteValueChanged = true;
                    }}
                    on:blur={(e) => {
                      if (websiteValueChanged) {
                        brokenLink = false;
                      }
                      applyDataTransforms();
                      checkAffiliateLinkFromWeblink(e.target.value);
                    }} />
                {:else}
                  <div class="single-line-preloader"><PreloadBox /></div>
                {/if}

                {#if isWeblinkAffiliate && affiliateLinkEnabled}
                  <img
                    data-tippy-content="Affiliate Link ON"
                    use:setupTooltip
                    class="link-circle-dollar"
                    src="/images/payout/circle-dollar.svg"
                    alt="affiliate-link-icon" />
                {/if}
                {#if mobile}
                  <img
                    on:click={() => {
                      window.open(`https://${editableWebResult?.website}`);
                    }}
                    alt="external-icon"
                    src={externalIcon}
                    style="margin-left: 5px; display: flex; visibility: {editableWebResult?.website
                      ? 'visible'
                      : 'hidden'}" />
                {/if}
              </div>
              <div class="single-more-info">
                <img src={emailIcon} alt="email-icon" />

                {#if editableWebResult?.email || !loadingData}
                  <input
                    autocomplete="new-password"
                    on:keyup={blurOnEnter}
                    class="purple-box-input"
                    class:invalid-input={invalidEmail}
                    type="text"
                    placeholder="Add an email"
                    bind:value={editableWebResult.email}
                    on:blur={(event) => {
                      if (validateEmail(event.target)) {
                        applyDataTransforms();
                      }
                    }}
                    on:focus={removeValidationErrors}
                    use:setupTippyForEmail={editableWebResult.email} />
                {:else}
                  <div class="single-line-preloader"><PreloadBox /></div>
                {/if}

                {#if mobile}
                  <img
                    on:click={() => {
                      window.open(`mailto:${editableWebResult?.email}`);
                    }}
                    alt="external-icon"
                    src={externalIcon}
                    style="margin-left: 5px; display: flex; visibility: {editableWebResult?.email
                      ? 'visible'
                      : 'hidden'}" />
                {/if}
              </div>
              <div class="single-more-info">
                <img src={instagramIcon} alt="instagram-icon" />

                {#if editableWebResult?.instagram_handle || !loadingData}
                  <input
                    autocomplete="new-password"
                    on:keyup={blurOnEnter}
                    class="purple-box-input"
                    placeholder="Add an instagram"
                    type="text"
                    bind:value={editableWebResult.instagram_handle}
                    on:blur={applyDataTransforms}
                    use:setupTippyForInstagram={editableWebResult.instagram_handle} />
                {:else}
                  <div class="single-line-preloader"><PreloadBox /></div>
                {/if}

                {#if mobile}
                  <img
                    on:click={() => {
                      window.open(`https://instagram.com/${editableWebResult?.instagram_handle}`);
                    }}
                    alt="external-icon"
                    src={externalIcon}
                    style="margin-left: 5px; display: flex; visibility: {editableWebResult?.instagram_handle
                      ? 'visible'
                      : 'hidden'}" />
                {/if}
              </div>
              <div class="single-more-info">
                <img src={phoneIcon} alt="phone-icon" />

                {#if editableWebResult?.phone || !loadingData}
                  <input
                    autocomplete="new-password"
                    on:keyup={blurOnEnter}
                    class="purple-box-input"
                    type="text"
                    placeholder="Add a phone"
                    bind:value={editableWebResult.phone}
                    on:blur={applyDataTransforms} />
                {:else}
                  <div class="single-line-preloader"><PreloadBox /></div>
                {/if}
                {#if mobile}
                  <img
                    on:click={() => {
                      window.open(`tel:${editableWebResult?.phone}`);
                    }}
                    alt="external-icon"
                    src={externalIcon}
                    style="margin-left: 5px; display: flex; visibility: {editableWebResult?.phone
                      ? 'visible'
                      : 'hidden'}" />
                {/if}
              </div>
            </div>
          {/if}
        </div>
      {/if}
    </div>

    <div class="right-side" class:hidden={mobile && currentMobileTab !== 'photos'}>
      {#if mode === 'new' && (loadingPreview || (webResult && !loadedImages))}
        <LoadingSkeleton loadingDelay={1000}>
          <div slot="input-photo-label" class="photos-label-container">
            <div class="photos-label">Select photos</div>
            <div class="photos-upload-button">
              <span>Upload</span>
            </div>
          </div>
          <div slot="input-photo-upload" class="photos-url-container">
            <input type="text" placeholder="Import photos from link" />
            <span class="photos-url-button">
              <i class="fa fa-spinner fa-spin" style="font-size: 12px; color: white;" />
            </span>
          </div>
        </LoadingSkeleton>
      {:else if webResult}
        <div class="photos-container">
          <div class="photos-label-container">
            <div class="photos-label">Select photos</div>
            <div class="photos-upload-button" on:click={uploadPhotos}>
              <span>Upload</span>
            </div>
          </div>
          <div class="photos-url-container">
            <input
              bind:this={importForLinkEl}
              type="text"
              placeholder="Import photos from link"
              on:keyup={(event) => {
                var which = event.which || event.keyCode || 0;
                if (which == 13) {
                  fetchImagesFromUrl();
                }
              }} />
            <span class="photos-url-button" on:click={fetchImagesFromUrl}>
              {#if loadingUrlImages}
                <i class="fa fa-spinner fa-spin" style="font-size: 12px; color: white;" />
              {:else}
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                    <rect x="0.399902" y="0.399902" width="11.2" height="11.2" fill="white" />
                  </mask>
                  <g mask="url(#mask0)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.28858 10.2537C4.92714 10.6713 4.97265 11.3028 5.39023
                      11.6643C5.80782 12.0257 6.43934 11.9802 6.80079
                      11.5626L11.0284 6.67842C11.1901 6.50123 11.2889 6.26565
                      11.2895 6.00699C11.2895 6.00616 11.2896 6.00533 11.2896
                      6.00451C11.2896 6.00434 11.2896 6.00417 11.2896
                      6.004C11.2896 5.97119 11.2879 5.93839 11.2847
                      5.90571C11.2787 5.84465 11.2671 5.78404 11.2499
                      5.72469C11.2107 5.5899 11.1427 5.46163 11.0457
                      5.34955L6.80079 0.44536C6.43934 0.0277758 5.80782 -0.0177345
                      5.39023 0.34371C4.97265 0.705153 4.92714 1.33668 5.28858
                      1.75426L8.10186 5.00451L1.79982 5.00451C1.24753 5.00451
                      0.799819 5.45222 0.799819 6.00451C0.799819 6.55679 1.24753
                      7.00451 1.79982 7.00451L8.10098 7.00451L5.28858 10.2537Z"
                      fill="white" />
                  </g>
                </svg>
              {/if}
            </span>
          </div>
          <div class="photo-gallery">
            {#if uploadingPhoto}
              <div
                class="photo-gallery-single"
                style="display: flex; justify-content: center; align-items:
                center; width: 143px; height: 143px; border: 4px solid #e4dff7;
                border-radius: 14px; margin-right: 8px; margin-bottom: 8px;">
                <div>
                  <i class="fa fa-spinner fa-spin" />
                </div>
              </div>
            {/if}

            {#each galleryImages as img (img.src)}
              <div class="photo-gallery-single" style={img.failed ? 'display: none' : ''}>
                <div
                  style={allowImageSelect && selectedUrls.indexOf(img.src) != -1 ? '' : 'display: none'}
                  class="select-image-number"
                  on:click|preventDefault={() => {
                    selectImage(img);
                  }}>
                  {selectedUrls.indexOf(img.src) + 1}
                </div>

                <div
                  class="gallery-single-image"
                  style="height: 100%; min-height: 143px; {img.loaded
                    ? 'display: none'
                    : 'display: grid; border: 0px;'}">
                  <PreloadBox />
                </div>

                <img
                  style={img.loaded ? 'display: block' : 'display: none'}
                  alt="#"
                  on:click|preventDefault={() => {
                    selectImage(img);
                  }}
                  on:load={(event) => onImageLoaded(event, img)}
                  on:error={() => onImageFailed(img)}
                  class="gallery-single-image"
                  class:gallery-single-image-selected={allowImageSelect && selectedUrls.includes(img.src)}
                  src={img.src} />

                <div
                  style={img.low_res ? '' : 'display: none'}
                  class="low-res-container"
                  on:click|preventDefault={() => {
                    selectImage(img);
                  }}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                      <rect width="12" height="12" fill="white" />
                    </mask>
                    <g mask="url(#mask0)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.92398 0.383219C6.41311 -0.127739 5.58483 -0.12774 5.07396 0.383218L0.383154 5.07483C-0.127717 5.58579 -0.127718 6.41421 0.383152 6.92517L5.07396 11.6168C5.58483 12.1277 6.41311 12.1277 6.92398 11.6168L11.6148 6.92517C12.1257 6.41421 12.1257 5.58579 11.6148 5.07483L6.92398 0.383219ZM6.10449 3.05636C6.28803 3.05636 6.46406 3.12987 6.59384 3.26074C6.72363 3.3916 6.79654 3.56909 6.79654 3.75416C6.79654 3.86846 6.79688 3.95803 6.79717 4.03321C6.79758 4.13792 6.79787 4.21471 6.79698 4.29149C6.79452 4.5026 6.78305 4.71362 6.74006 5.50487C6.72288 5.82111 6.70066 6.23003 6.67197 6.76869C6.67197 6.92323 6.61109 7.07143 6.50272 7.1807C6.39435 7.28998 6.24736 7.35136 6.09411 7.35136C5.94085 7.35136 5.79386 7.28998 5.68549 7.1807C5.57712 7.07143 5.51624 6.92323 5.51624 6.76869C5.48661 6.21665 5.46388 5.80269 5.44648 5.48566C5.40549 4.73912 5.39401 4.52998 5.39135 4.32072C5.39032 4.23928 5.39062 4.15783 5.39104 4.04467C5.39133 3.96646 5.39167 3.87311 5.39167 3.75416C5.39163 3.66074 5.4102 3.56825 5.44627 3.4822C5.48234 3.39614 5.53518 3.31827 5.60166 3.25319C5.66813 3.18811 5.74689 3.13715 5.83327 3.10334C5.91964 3.06953 6.01187 3.05355 6.10449 3.05636ZM6.10449 9.28778C5.9549 9.28709 5.80887 9.24178 5.68478 9.15755C5.5607 9.07333 5.46411 8.95396 5.40718 8.81448C5.35025 8.675 5.33554 8.52166 5.36489 8.37376C5.39424 8.22587 5.46634 8.09004 5.57211 7.98339C5.67788 7.87674 5.81259 7.80404 5.95926 7.77444C6.10594 7.74485 6.25802 7.75969 6.39635 7.81709C6.53468 7.87449 6.65306 7.97188 6.73659 8.097C6.82012 8.22212 6.86506 8.36937 6.86574 8.52019C6.8662 8.62112 6.84682 8.72114 6.80873 8.81448C6.77063 8.90782 6.71458 8.99262 6.6438 9.06399C6.57302 9.13536 6.48892 9.19188 6.39635 9.23029C6.30378 9.2687 6.20458 9.28824 6.10449 9.28778Z"
                        fill="url(#paint0_angular)" />
                    </g>
                    <defs>
                      <radialGradient
                        id="paint0_angular"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(5.99897 6) rotate(44.9951) scale(8.48601 8.48746)">
                        <stop offset="0.745949" stop-color="#FFDAAF" />
                        <stop offset="0.75" stop-color="#FFB768" />
                      </radialGradient>
                    </defs>
                  </svg>
                  <div class="low-res-text">Low resolution</div>
                </div>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

{#if mobile && !loadingPreview && editableWebResult}
  <div class="details-photo-bar">
    <div
      on:click={() => {
        currentMobileTab = 'details';
        jQuery('.b-modal').animate({ scrollTop: 260 }, 'fast');
      }}
      class="details-tab"
      class:selected-tab={currentMobileTab === 'details'}>
      <span>Details</span>
    </div>
    <div
      on:click={() => {
        currentMobileTab = 'photos';
        jQuery('.b-modal').animate({ scrollTop: 145 }, 'fast');
      }}
      class="details-tab"
      class:selected-tab={currentMobileTab === 'photos'}>
      <span>Photos</span>
    </div>
  </div>
{/if}

{#if (!loadingPreview || !mobile) && editableWebResult}
  <div
    class="step-2-bottom-bar-container"
    class:mobile-step-2-bottom-bar-container={mobile}
    style={mobile ? `width: calc(100% - ${bottomBarWidthOffset}px);` : ''}>
    <div class="step-2-bottom-bar" class:desktop-bottom-bar={!mobile} class:mobile-bottom-bar={mobile}>
      {#if !mobile && showBack}
        {#if mode === 'new'}
          <span
            class="btns back-btn"
            on:click={() => {
              removeValidationErrors();
              moveToStepOne();
            }}>Back</span>
        {/if}
        <span style="width: 100%" />
      {/if}
      {#if !mobile && showCancel}
        {#if mode === 'new'}
          <span
            class="btns back-btn"
            on:click={() => {
              closeFn();
            }}>Cancel</span>
        {/if}
        <span style="width: 100%" />
      {/if}
      {#if showSkip}
        <span
          class="btns skip-btn"
          on:click={() => {
            triggerSkip();
          }}>
          Skip
        </span>
      {/if}
      <span
        class="btns done-btn"
        on:click={() => {
          if (loadingPreview) {
            return;
          } else if (finishedLoading) {
            triggerDone();
          } else {
            triggerDoneAfterLoading = true;
          }
        }}>
        {#if loadingPreview || triggerDoneAfterLoading}
          <i class="fa fa-spinner fa-spin" />
        {:else}{@html doneButtonHtml}{/if}
      </span>
    </div>
  </div>
{/if}
{#if BrowserUtils.isIOS()}
  <input type="text" id="mobile-grid-focus-input" style="opacity: 0; height: 0px;" />
{/if}
